var React = require('react');

function ContactCircleInline (props) {
    return React.createElement("svg",props,React.createElement("circle",{"id":"path","cx":"400","cy":"400","r":"400","stroke":"#000000","fill":"none","strokeWidth":"2","strokeLinecap":"round"}));
}

ContactCircleInline.defaultProps = {"id":"circle-2","viewBox":"0 0 800 800","width":"800","height":"800","xmlSpace":"preserve"};

module.exports = ContactCircleInline;

ContactCircleInline.default = ContactCircleInline;
